'use client'

import { ExclamationCircleIcon, ExclamationTriangleIcon } from '@heroicons/react/24/outline'

import { cn } from '@src/utils/tailwind'

export interface AlertProps {
  type: 'error' | 'success' | 'info' | 'warning'
  className?: string
  iconClassName?: string
  message?: React.ReactNode | string
  children?: React.ReactNode
}

export function Alert({ message, type, className, iconClassName, children }: AlertProps) {
  const Icons = {
    error: ExclamationCircleIcon,
    success: ExclamationCircleIcon,
    info: ExclamationCircleIcon,
    warning: ExclamationTriangleIcon,
  }

  const Icon = Icons[type]

  return (
    <div
      role="alert"
      className={cn([
        'mt-6 flex items-center rounded-md bg-blue-200 p-4 text-body-md text-blue-800',
        { 'bg-red-200 text-red-800': type === 'error' },
        { 'bg-green-200 text-green-800': type === 'success' },
        { 'bg-blue-200 text-blue-800': type === 'info' },
        { 'bg-[#F5EEC8] text-[#9B6500]': type === 'warning' },
        className,
      ])}
    >
      {
        <Icon
          className={cn([
            'mr-3 inline-block size-6 shrink-0 stroke-blue-800',
            iconClassName,
            { 'stroke-bodi-red-deep-500': type === 'error' },
            { 'stroke-green-800': type === 'success' },
            { 'stroke-blue-800': type === 'info' },
            { 'stroke-[#9B6500]': type === 'warning' },
          ])}
        />
      }
      {message && <p>{message}</p>}
      {children}
    </div>
  )
}
